import React from "react";
import PropTypes from "prop-types";

import { Field } from "react-final-form";

const RadioFilterIndicator = ({ filter, value }) => {
  if (!value || value === "" || filter.type === "date") {
    return null;
  }

  let selectedOptionsString = "";

  if (filter.type === "radios") {
    const selectedOptionsAsString = filter.options
      .filter((option) => value === option.key)
      .map((option) => option.title);

    if (selectedOptionsAsString.length <= 2) {
      selectedOptionsString = selectedOptionsAsString.join(" en ");
    }

    if (selectedOptionsAsString.length > 2) {
      const first = selectedOptionsAsString.slice(0, -1);
      const second = selectedOptionsAsString.slice(
        selectedOptionsAsString.length - 1
      );

      selectedOptionsString = `${first.join(", ")} en ${second[0]}`;
    }
  } else {
    selectedOptionsString = value;
  }

  return (
    <Field name={filter.key}>
      {({ input }) => (
        <button
          className="radio-filter-indicator"
          onClick={() => {
            input.onChange();
          }}
          type="button"
        >
          {filter.title}: <strong>{selectedOptionsString}</strong>
        </button>
      )}
    </Field>
  );
};

RadioFilterIndicator.propTypes = {
  filter: PropTypes.shape().isRequired,
  value: PropTypes.string,
};

RadioFilterIndicator.defaultProps = {
  value: "",
};

export default RadioFilterIndicator;
